import React from 'react';
import { Dropdown } from 'react-bootstrap';

export const DEFAULT_VIDEO_ORDER = 'createdAt:desc';

export const VIDEO_SORT_OPTIONS = [
  { value: 'title:asc', label: 'Title A–Z' },
  { value: 'title:desc', label: 'Title Z–A' },
  { value: 'createdAt:asc', label: 'Date (oldest)' },
  { value: 'createdAt:desc', label: 'Date (newest)' },
] as const;

export type VideoOrder = typeof VIDEO_SORT_OPTIONS[number]['value'];

export function SortGlyph() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 2.5v11M4 2.5L2 4.5M4 2.5l2 2M12 13.5v-11M12 13.5l2-2M12 13.5l-2-2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface VideoSortDropdownProps {
  order: string;
  onChange: (order: VideoOrder) => void;
  className?: string;
  toggleClassName?: string;
}

export function VideoSortDropdown({
  order,
  onChange,
  className,
  toggleClassName,
}: VideoSortDropdownProps) {
  const currentLabel = VIDEO_SORT_OPTIONS.find((option) => option.value === order)?.label
    || 'Date (newest)';

  return (
    <Dropdown alignRight className={className}>
      <Dropdown.Toggle
        variant="link"
        size="sm"
        className={toggleClassName}
        aria-label="Sort videos"
        title={`Sort: ${currentLabel}`}
      >
        <SortGlyph />
      </Dropdown.Toggle>
      <Dropdown.Menu data-video-sort-menu="true">
        {VIDEO_SORT_OPTIONS.map((option) => (
          <Dropdown.Item
            key={option.value}
            active={order === option.value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
